import type { ComponentType } from 'react';

export interface DocxPreviewRendererProps {
  file: File;
  onLoadComplete?: () => void;
  onLoadStart?: () => void;
  onError?: (msg: string) => void;
}

export type DocxPreviewRenderer = ComponentType<DocxPreviewRendererProps>;

let registeredDocxPreviewRenderer: DocxPreviewRenderer | null = null;

/**
 * Host apps can replace the shared fallback DOCX preview with their canonical
 * renderer while keeping `@auw/workspace-ui` independent from host-local code.
 */
export function setDocxPreviewRenderer(renderer: DocxPreviewRenderer | null): void {
  registeredDocxPreviewRenderer = renderer;
}

export function getDocxPreviewRenderer(): DocxPreviewRenderer | null {
  return registeredDocxPreviewRenderer;
}
